
import { atom } from "recoil";
import { IReportTemplate } from "../models/IReportTemplate";

  export const reportTemplateState = atom({
    key: 'reportTemplate', // unique ID (with respect to other atoms/selectors)
    default:[] as IReportTemplate [] // default value (aka initial value)
  });